export enum Subject {
  Billing = 'Billing',
  AdminPanel = 'AdminPanel',
  Role = 'Role',
  Viewer = 'Viewer',
  ViewerComments = 'ViewerComments',
  Payment = 'Payment',
  Project = 'Project',
  DemoProject = 'DemoProject',
  ValidationResults = 'ValidationResults',
  ValidationMeasurements = 'ValidationMeasurements',
  ValidationActivityAssignment = 'ValidationActivityAssignment',
  ValidationClassification = 'ValidationClassification',
  ValidationModelCheck = 'ValidationModelCheck',
  InactiveScenarios = 'InactiveScenarios',
  Application = 'Application',
  KreoProvidedDb = 'KreoProvidedDb',
  SequenceStep = 'SequenceStep',
  PlanFeatures = 'PlanFeatures',
  Company = 'Company',
  Guests = 'Guests',
  Employees = 'Employees',
  Subcontractors = 'Subcontractors',
  Database = 'Database',
  Cost = 'Cost',
  CostEstimate = 'CostEstimate',
  Gantt = 'Gantt',
  GanttResources = 'GanttResources',
  Dashboard = 'Dashboard',
  Scenarios = 'Scenarios',
  BidPricing = 'BidPricing',
  BidPricingInvitation = 'BidPricingInvitation',
  BidPricingWorkPackages = 'BidPricingWorkPackages',
  FourDVisualisation = 'FourDVisualisation',
  QuantityTakeOff3d = 'QuantityTakeOff3d',
  QuantityTakeOffReport = 'QuantityTakeOffReport',
  QuantityTakeOff2d = 'QuantityTakeOff2d',
  QuantityTakeOffCustomFilters = 'QuantityTakeOffCustomFilters',
  ElementUniclassClassification = 'ElementUniclassClassification',
  ModelManagement = 'ModelManagement',
  SmartLook = 'SmartLook',
  ImportSchedules2D = 'ImportSchedules2D',
  Takeoff2DReport = 'Takeoff2DReport',
  Takeoff2DMeasurement = 'Takeoff2DMeasurement',
  Takeoff2DAutoMeasure = 'Takeoff2DAutoMeasure',
  Takeoff2dAnnotations = 'Takeoff2dAnnotations',
  Takeoff2dMeasurementAutocomplete = 'Takeoff2dMeasurementAutocomplete',
  Project2DTemplates = 'Project2DTemplates',
}
